var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Logo",
    width: 102,
    height: 40,
    viewBox: "0 0 102 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "bGuest",
    transform: "translate(51 30)",
    fill: "#e24444",
    fontSize: 31,
    fontFamily: "NTJosefine, NT Josefine"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -50,
    y: 0,
    fill: "#e24444"
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fill: "#ffffff"
  }, "Guest"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.220bb12f4d11aeec7b89d07f581ad5c6.svg";
export { ForwardRef as ReactComponent };